import { Bonus, BonusCampaign, PersonBonus, Vehicle } from '@esportal/portal-service';
import {
	Breakpoints,
	Container,
	ContainerPadding,
	styled,
	Text,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import React, { useContext } from 'react';
import { PortalContext } from '../../context/PortalContext';
import {
	getPromotionByName,
	isPersonNotWinnerInPromotion,
	isPersonWinnerInPromotion,
	isPromotionOpened,
	personParticipatedInPromotion,
} from '../../helpers/promotions-helper';
import { IdWeChargePopupLayer } from '../idWecharge/IdWeChargePopupLayer';
import { PromotionPopupLayer } from '../promotionManager/promotionPopupLayer';
import { AlertType } from './alerts-type';
import { AlertCard } from './components/alert-card';

const AlertsContainer = styled(Container)`
	padding-left: 4.16vw;
	padding-right: 4.16vw;
`;

const AlertsStackedContainer = styled(Container)`
	display: flex;
	flex-direction: column;
	> div {
		justify-content: space-between;
		> div {
			@media (max-width: 960px) {
				width: 100%;
			}
		}
	}
`;

const FlexItem = styled.div<{ paddingRight: boolean; paddingBottom: boolean }>`
	height: 100%;
	padding-right: ${({ paddingRight }: { paddingRight: boolean }) => (paddingRight ? 'var(--size-grid001)' : '0')};
	padding-bottom: ${({ paddingBottom }: { paddingBottom: boolean }) =>
		paddingBottom ? 'var(--size-grid001)' : 'var(--size-dynamic0020)'};

	@media (max-width: 960px) {
		padding-bottom: ${({ paddingBottom }: { paddingBottom: boolean }) =>
			paddingBottom ? 'var(--size-grid001)' : 'var(--size-grid001)'};
		padding-right: 0px;
	}
`;

interface VehicleWithAlerts {
	alertType: AlertType;
	bonus?: Bonus;
	vehicle: Vehicle;
}

interface PersonWithAlerts {
	alertType: AlertType;
	bonus?: Bonus;
}

type CombinedAlert = VehicleWithAlerts | PersonWithAlerts;

export const Alerts: React.FC<{
	personBonus: PersonBonus | null;
}> = ({ personBonus }) => {
	const { portalService } = useContext(PortalContext);
	const vehicles = portalService.getPersonVehicles().getValue();
	const promotions = portalService.getPerson().getValue()?.portalUser.data.clubVW.promotions;

	//const userPromotions = userData?.portalUser.data.promotions;
	const promotionLayerRef = React.useRef<HTMLDivElement | null>(null);
	const [alertTypePromotion, setAlertTypePromotion] = React.useState<AlertType | null>(null);
	const [isPromotionPopupVisible, setIsPromotionPopupVisible] = React.useState<boolean>(false);

	const IdWeChargeLayerRef = React.useRef<HTMLDivElement | null>(null);
	const [isIdWeChargePopupVisible, setisIdWeChargePopupVisible] = React.useState<boolean>(false);

	let mastersCarretera = undefined;
	let laLiga = undefined;
	let elClasico = undefined;

	if (promotions && promotions.length > 0) {
		const mastersPromotion = getPromotionByName(promotions, 'MastersCarretera2026');
		const laLigaPromotion = getPromotionByName(promotions, 'LaLigaLanzamiento2026');
		const elClasicoPromotion = getPromotionByName(promotions, 'ElClasico2026');

		if (mastersPromotion) {
			if (isPersonNotWinnerInPromotion(mastersPromotion)) {
				mastersCarretera = AlertType.Masters26_NoWinner;
			} else if (isPersonWinnerInPromotion(mastersPromotion)) {
				mastersCarretera = AlertType.Masters26_Winner;
			} else if (personParticipatedInPromotion(mastersPromotion)) {
				mastersCarretera = AlertType.Masters26_Enrolled;
			} else if (isPromotionOpened(mastersPromotion)) {
				mastersCarretera = AlertType.Masters26_Open;
			} else {
				mastersCarretera = undefined;
			}
		}

		if (laLigaPromotion) {
			if (isPersonNotWinnerInPromotion(laLigaPromotion)) {
				laLiga = AlertType.LaLiga26_NoWinner;
			} else if (personParticipatedInPromotion(laLigaPromotion)) {
				laLiga = AlertType.LaLiga26_Enrolled;
			} else if (isPromotionOpened(laLigaPromotion)) {
				laLiga = AlertType.LaLiga26_Open;
			} else {
				laLiga = undefined;
			}
		}

		if (elClasicoPromotion) {
			if (isPersonNotWinnerInPromotion(elClasicoPromotion)) {
				elClasico = AlertType.ElClasico26_NoWinner;
			} else if (personParticipatedInPromotion(elClasicoPromotion)) {
				elClasico = AlertType.ElClasico26_Enrolled;
			} else if (isPromotionOpened(elClasicoPromotion)) {
				elClasico = AlertType.ElClasico26_Open;
			} else {
				elClasico = undefined;
			}
		}
	}

	// const detectTouranAlert = (): boolean => {
	//  if (!vehicles || !vehicles.vehicles) {
	//      return false;
	//  }
	//  return vehicles.vehicles.some((vehicle) => {
	//      const carlineSli = vehicle.commercialDenominationSli?.toLowerCase();

	//      const oldCar = checkOldCar(vehicle.licenseDate, 3);
	//      if (oldCar) {
	//          return false;
	//      }

	//      const isGolfVariant = carlineSli?.includes('golf') && carlineSli?.includes('variant');
	//      const isTouran = carlineSli?.includes('touran');
	//      const isAllspace = carlineSli?.includes('allspace');

	//      return isGolfVariant || isTouran || isAllspace;
	//  });
	// };

	const noVehicleOrder2025 = (): boolean => {
		if (!vehicles) {
			return false;
		}

		// Verificar si hay alguna fecha de 2025
		for (const order of vehicles.orders) {
			if (order.orderDate && new Date(order.orderDate).getFullYear() === 2025) {
				return false;
			}
		}

		for (const vehicle of vehicles.vehicles) {
			if (vehicle.deliveryDate && new Date(vehicle.deliveryDate).getFullYear() === 2025) {
				return false;
			}
		}

		return true;
	};

	const findBonusAlert = (campaign: BonusCampaign, alertType: AlertType): CombinedAlert | null => {
		const campaignInBonus = personBonus?.bonus.find((b) => b.campaign === campaign);
		if (campaignInBonus) {
			if (campaignInBonus.frame) {
				const vehicleInfo = portalService.getVehicleByFrame(campaignInBonus.frame).getValue();
				if (vehicleInfo) return { alertType, bonus: campaignInBonus, vehicle: vehicleInfo };
			} else {
				return { alertType, bonus: campaignInBonus };
			}
		}
		return null;
	};

	const getAllAlerts = (): CombinedAlert[] => {
		const alerts: CombinedAlert[] = [];

		if (elClasico) alerts.push({ alertType: elClasico });

		//Falta saber prio
		if (laLiga) alerts.push({ alertType: laLiga });

		// 1. Escuela ID 1to1
		const escuelaID = findBonusAlert(BonusCampaign.OneToOne_ID, AlertType.OneToOneID);
		if (escuelaID) alerts.push(escuelaID);

		// 2. Escuela GTI Safety Drive
		const escuelaPolo = findBonusAlert(BonusCampaign.OneToOne_Polo, AlertType.OneToOnePolo);
		if (escuelaPolo) alerts.push(escuelaPolo);

		// 3. Entrega Ideal
		const entregaIdeal = findBonusAlert(BonusCampaign.ENTREGA_IDEAL, AlertType.EntregaIdeal);
		if (entregaIdeal) alerts.push(entregaIdeal);

		//4. Id. WeCharge

		// if (noVehicleOrder2025() && !findBonusAlert(BonusCampaign.IDWeChargePostPedido, AlertType.IDWeChargePostPedido)) {
		// 	console.log(findBonusAlert(BonusCampaign.IDWeChargePostPedido, AlertType.IDWeChargePostPedido));
		// 	alerts.push({ alertType: AlertType.IDWeCharge });
		// }

		//4.5 Id. WeChargePostPedido
		const IDWeChargePostPedido = findBonusAlert(BonusCampaign.IDWeChargePostPedido, AlertType.IDWeChargePostPedido);
		if (IDWeChargePostPedido) alerts.push(IDWeChargePostPedido);

		//5. GTI
		// alerts.push({ alertType: AlertType.GolfGTI });

		//6. Masters de la Carretera
		if (mastersCarretera) alerts.push({ alertType: mastersCarretera });

		//7. Mantenimiento y Pre ITV
		if (vehicles?.vehicles) {
			vehicles.vehicles.forEach((vehicle) => {
				if (vehicle.alertNextMaintenance) {
					alerts.push({ alertType: AlertType.Mantenimiento, vehicle });
				}
				if (vehicle.alertPreITV) {
					alerts.push({ alertType: AlertType.PreITV, vehicle });
				}
			});
		}
		return alerts;

		//DESACTIVADAS
		// NO. Campaña Touran
		// if (detectTouranAlert()) {
		//  alerts.push({ alertType: AlertType.Touran });
		// }

		// NO. Golf GTI 50 Aniversario
		// alerts.push({ alertType: AlertType.GolfGTI });
	};

	const getCombinedAlerts = () => {
		const allAlerts = getAllAlerts();

		if (allAlerts.length >= 3) {
			return allAlerts.slice(0, 3);
		}

		return allAlerts;
	};

	const filteredFirstThreeAlerts = getCombinedAlerts();

	return (
		<>
			<PromotionPopupLayer
				alertType={alertTypePromotion}
				isPromotionPopupVisible={isPromotionPopupVisible}
				setIsPromotionPopupVisible={setIsPromotionPopupVisible}
				promotionLayerRef={promotionLayerRef}
			/>
			{noVehicleOrder2025() && (
				<IdWeChargePopupLayer
					IsIdWeChargePopUpVisible={isIdWeChargePopupVisible}
					setIsIdWeChargePopUpVisible={setisIdWeChargePopupVisible}
					IdWeChargeLayerRef={IdWeChargeLayerRef}
				/>
			)}

			{filteredFirstThreeAlerts.length > 0 && (
				<AlertsContainer
					data-testid="alerts"
					padding={{
						top: {
							[Breakpoints.default]: ContainerPadding.dynamic0250,
							[Breakpoints.b960]: ContainerPadding.dynamic0200,
						},
						bottom: {
							[Breakpoints.default]: ContainerPadding.dynamic0250,
							[Breakpoints.b960]: ContainerPadding.dynamic0200,
						},
					}}
					stretchContent
				>
					<Container data-testid="alerts-title" stretchContent>
						<Text appearance={TokenTextAppearance.headline500} color={TokenTextColor.primary}>
							{'Que no se\u00A0'}
							<Text appearance={TokenTextAppearance.headline500} color={TokenTextColor.primary} bold>
								{'te escape'}
							</Text>
						</Text>
					</Container>

					<AlertsStackedContainer
						data-testid="alerts-cards-container"
						padding={{
							top: {
								[Breakpoints.default]: ContainerPadding.dynamic0150,
							},
						}}
					>
						{filteredFirstThreeAlerts.map((alert: CombinedAlert, index) => {
							const alertsCount = filteredFirstThreeAlerts.length;
							const shouldHavePaddingRight = (alertsCount > 2 && index === 1) || (alertsCount === 2 && index === 0);
							const shouldHavePaddingBottom = alertsCount > 2 && index === 0;

							return (
								<FlexItem
									key={index}
									className="flex-item"
									paddingRight={shouldHavePaddingRight}
									paddingBottom={shouldHavePaddingBottom}
								>
									<AlertCard
										className={`alert-card-${index}`}
										alertType={alert.alertType}
										numberOfAlerts={alertsCount}
										vehicle={'vehicle' in alert ? alert.vehicle : undefined}
										alertPosition={index}
										bonus={alert.bonus ?? null}
										setIsIdWeChargePopUpVisible={setisIdWeChargePopupVisible}
										setIsPromotionPopupVisible={setIsPromotionPopupVisible}
										setAlertTypePromotion={setAlertTypePromotion}
									/>
								</FlexItem>
							);
						})}
					</AlertsStackedContainer>
				</AlertsContainer>
			)}
		</>
	);
};
